export const SERVICES = [
  {
    slug: "bespoke-joinery",
    title: "Bespoke Joinery",
    tag: "Handcrafted",
    short: "One-of-a-kind timber pieces designed, built and installed by skilled joiners in Sheffield.",
    long: "From sash windows and shaker doors to library shelving and hardwood benches, every piece is crafted in solid timber to your exact brief. Traditional jointing, hand-finished detail, and materials that will age beautifully for generations.",
    image:
      "https://images.unsplash.com/photo-1547609434-b732edfee020?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxiZXNwb2tlJTIwY2FycGVudHJ5JTIwd29vZHdvcmtpbmclMjBjcmFmdHNtYW5zaGlwfGVufDB8fHx8MTc4MzAyNjA4OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "extensions-renovations",
    title: "Extensions & Renovations",
    tag: "Full Build",
    short: "Single-storey, wrap-around and loft extensions delivered from foundation to final coat.",
    long: "We handle the entire build — structural work, roofing, plastering and finishing — coordinating trades so you deal with one team. Every project is planned to add real, lasting value to your home.",
    image:
      "https://images.unsplash.com/photo-1754063257992-bb9eabdbdd86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBob3VzZSUyMGV4dGVuc2lvbiUyMGV4dGVyaW9yfGVufDB8fHx8MTc4MzAyNjA4OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "decking-outdoor",
    title: "Decking & Outdoor Living",
    tag: "Outdoor",
    short: "Hardwood decking, pergolas and garden rooms that turn any garden into a second living space.",
    long: "Whether you want a low-maintenance composite deck or a full timber pergola with lighting, we design and build outdoor spaces that hold up to Yorkshire weather and feel great underfoot.",
    image:
      "https://images.unsplash.com/photo-1621506821957-1b50ab7787a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHx3b29kZW4lMjBkZWNraW5nJTIwb3V0ZG9vciUyMGxpdmluZ3xlbnwwfHx8fDE3ODMwMjYwODl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "staircases",
    title: "Staircases",
    tag: "Statement Feature",
    short: "Bespoke timber staircases — from traditional oak to floating modern designs.",
    long: "Staircases are the heart of a home. We design, manufacture and fit staircases in oak, ash, walnut and painted finishes, with hand-turned or steel balustrades, always to building regs.",
    image:
      "https://images.unsplash.com/photo-1580911498851-4999ad5327b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3b29kZW4lMjBzdGFpcmNhc2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODMwMjYwODl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "fitted-furniture",
    title: "Fitted Furniture",
    tag: "Made to Measure",
    short: "Alcove units, wardrobes, media walls and home offices built into your space.",
    long: "Every millimetre used, every joint precise. We survey, design and hand-build fitted furniture — wardrobes, bookcases, media walls and home offices — sprayed in-house for a factory-grade finish.",
    image:
      "https://images.unsplash.com/photo-1722349674028-a148f4364e43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxmaXR0ZWQlMjBmdXJuaXR1cmUlMjB3YXJkcm9iZSUyMGN1c3RvbXxlbnwwfHx8fDE3ODMwMjYwODl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "general-building",
    title: "General Building Work",
    tag: "Trusted Trades",
    short: "Brickwork, roofing, groundworks and refurbishments — the full building package.",
    long: "From small repairs to full refurbishments, our team handles brickwork, roofing, groundworks and plastering. One trusted contact, one insured team, one job done properly.",
    image:
      "https://images.unsplash.com/photo-1660361338517-8c8fbb3ac264?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZSUyMGV4dGVuc2lvbiUyMGV4dGVyaW9yfGVufDB8fHx8MTc4MzAyNjA4OXww&ixlib=rb-4.1.0&q=85",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Sean and Rocky built us a stunning oak staircase and completely re-fitted our living room. The craftsmanship is genuinely on another level.",
    author: "Emma H.",
    location: "Fulwood, Sheffield",
  },
  {
    quote:
      "Turned up when they said, tidied up every night, and finished the rear extension a week ahead of schedule. We couldn't recommend Woodland Joinery more.",
    author: "David & Sarah P.",
    location: "Dronfield",
  },
  {
    quote:
      "Bespoke wardrobes across the whole master bedroom — flawless finish. You can tell they actually care about the details.",
    author: "Michael R.",
    location: "Chesterfield",
  },
  {
    quote:
      "Our garden decking has completely transformed how we use the house. Beautiful timber, brilliant team.",
    author: "Louise K.",
    location: "Ecclesall, Sheffield",
  },
];

export const CONTACT = {
  sean: { name: "Sean", phone: "+44 7856 925823", tel: "tel:+447856925823" },
  rocky: { name: "Rocky", phone: "+44 7375 808008", tel: "tel:+447375808008" },
  email: "info@woodlandjoinery.co.uk",
  area: "Sheffield & Surrounding Areas",
  socials: {
    instagram: "#",
    facebook: "#",
    tiktok: "#",
  },
};
